<footer>
    <p> The Goosicorn™ Team - Magical Quality Stuff</p>
</footer>

<style>
    footer {
        width: 100%;
        height: var(--footer-height);
        background: var(--dark-background);
        padding: 0 10px;
        position: fixed;
        bottom: 0;
        z-index: 1000;
        display: flex;
        justify-content: center;
        align-items: center;
        border-top: 2px solid #232323;
        font-size: 0.9em;
    }
</style>
